import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { IHandhole } from '@rfm/shared-interfaces';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { IConduit } from '@rfm/shared-interfaces';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TextareaModule } from 'primeng/textarea';
import { ConduitService } from '../../../../../shared/services/fiber-management/conduit.service.mjs';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-conduit-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputSwitchModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
  ],
  templateUrl: './conduit-edit.component.html',
  styleUrls: ['./conduit-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
 
})
export class ConduitEditComponent implements OnInit {
  @Input() displayModal: boolean = false;
  @Input() order: Order | null = null;
  @Output() closeModal = new EventEmitter<void>();
  conduitForm!: FormGroup;
  isLoading = true;
  conduitId!: string;
  taskForm = new FormGroup({
    serviceName: new FormControl(''),
    clientName: new FormControl('Kathryn Murphy'),
    dueDate: new FormControl(new Date()),
    status: new FormControl('Paid'),
    items: new FormControl(2),
    total: new FormControl('$0'),
    orderId: new FormControl('#0145'),
  });
  clientPhoto = 'https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'; // Replace with actual image URL

  statusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ];

  itemOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
  ];
  saveChanges() {
    console.log('Saving:', this.order);
    this.closeModal.emit();
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private conduitService: ConduitService
  ) {}

  ngOnInit(): void {
    this.conduitId = this.route.snapshot.paramMap.get('id')!;
    if (this.conduitId) {
      this.loadConduit(this.conduitId);
    }
  }

  loadConduit(id: string): void {
    this.conduitService.get(id)
      .then((response) => {
         let conduit: IConduit| undefined = response?.data;
        this.conduitForm = this.fb.group({
          size: [conduit?.size, Validators.required],
          status: [conduit?.status, Validators.required],
          coordinates: [conduit?.overlay_data, Validators.required],
          handholeId_start: [conduit?.handhole_start?.id, Validators.required],
          handholeId_end: [conduit?.handhole_end?.id, Validators.required],
          couplings: [conduit?.couplings],
          notes: [conduit?.comments],
        });
        this.isLoading = false;
      })
      .catch((error) => {
        console.error('Error loading conduit:', error);
        this.isLoading = false;
      });
  }

  onSubmit(): void {
    if (this.conduitForm.valid) {
      const updatedConduit: IConduit = { id: this.conduitId, ...this.conduitForm.value };
      this.isLoading = true;
      this.conduitService.update(updatedConduit)
        .then(() => {
          console.log('Conduit updated successfully');
          this.router.navigate(['/conduit/list']);
        })
        .catch((error) => {
          console.error('Error updating conduit:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
